import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const inputOnMobiles = media.tablet`
  width: 74px;
`;

export const InputsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SizeInput = styled.input`
  width: 70px;
  height: 40px;
  border: 1px solid #ccdde6;
  box-sizing: border-box;
  border-radius: 5px;
  text-align: center;
  outline: none;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.01em;
  color: #292a2b;
  padding: 0 3px;
  ${inputOnMobiles}

  &:disabled {
    color: #919eaa;
    background-color: #fff;
  }
`;

export const InputsDivider = styled.div`
  margin: 0 11px;
  color: #292a2b;
  font-size: 11px;
  line-height: 19px;
  letter-spacing: 0.01em;
`;
